// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2GjdW","modal":"Modal_modal__P3_V5","modalImg":"Modal_modalImg__1ybZJ"};